import { render, staticRenderFns } from "./FileManagerPopUp.vue?vue&type=template&id=10d7d78a&"
import script from "./FileManagerPopUp.vue?vue&type=script&lang=js&"
export * from "./FileManagerPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports